var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "personcenter" }, [
    _c("div", { staticClass: "wall" }, [
      _vm.isShow
        ? _c("div", [
            _c("div", { staticClass: "loginInfo-block" }, [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.goSM("myinfo")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "icon-avater",
                    attrs: { src: _vm.img },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-block" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(this.userInfo.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "phone" }, [
                      _vm._v(_vm._s(this.userInfo.phone)),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "right-button" }, [
                _vm.userInfo.is_smrz != "yes"
                  ? _c(
                      "div",
                      {
                        staticClass: "rz-button",
                        on: {
                          click: function ($event) {
                            return _vm.goSM("myinfoupdate")
                          },
                        },
                      },
                      [_vm._v("\n            未实名认证\n          ")]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "rz-button",
                        on: {
                          click: function ($event) {
                            return _vm.goSM("myinfo")
                          },
                        },
                      },
                      [_vm._v("\n            已实名认证\n          ")]
                    ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isShow
        ? _c(
            "div",
            { staticClass: "login-block" },
            [
              _c(
                "router-link",
                {
                  staticClass: "user-operate",
                  attrs: { to: { name: "login", query: { back: true } } },
                },
                [_c("span", { staticClass: "btn-login" }, [_vm._v("请登录")])]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "line-block" }, [
      _c(
        "div",
        {
          staticClass: "icon-block",
          on: {
            click: function ($event) {
              return _vm.goPage("browsinghistory")
            },
          },
        },
        [_vm._m(0), _vm._v(" "), _c("div", [_vm._v("浏览历史")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "icon-block",
          on: {
            click: function ($event) {
              return _vm.goPage("checkingmanagement")
            },
          },
        },
        [_vm._m(1), _vm._v(" "), _c("div", [_vm._v("看房管理")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "icon-block",
          on: {
            click: function ($event) {
              return _vm.goPage("contractmanagement")
            },
          },
        },
        [_vm._m(2), _vm._v(" "), _c("div", [_vm._v("合同订单")])]
      ),
      _vm._v(" "),
      _vm._m(3),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "myhouse" }, [
      _c("div", { staticClass: "house-title" }, [_vm._v("我的房子")]),
      _vm._v(" "),
      _c("div", { staticClass: "house-body" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "hd-text", on: { click: _vm.goRenWu } }, [
          _vm._v("点击添加我的房子"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.DQ_list.length > 0
      ? _c(
          "div",
          {
            staticClass: "myhouse",
            staticStyle: { "margin-top": "0.3rem !important" },
            on: {
              click: function ($event) {
                return _vm.gopage_ht(_vm.DQ_list[0])
              },
            },
          },
          [
            _c("div", { staticClass: "house-title" }, [_vm._v("待办订单")]),
            _vm._v(" "),
            _c("div", { staticClass: "db-body" }, [
              _c("div", { staticClass: "line" }, [
                _c("div", { staticClass: "line-pram" }, [_vm._v("合同类型")]),
                _vm._v(" "),
                _c("div", { staticClass: "line-text" }, [
                  _vm.DQ_list[0].type == "mmrw"
                    ? _c("div", [_vm._v("买卖合同")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.DQ_list[0].type == "mmls_rw"
                    ? _c("div", [_vm._v("买卖两书")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.DQ_list[0].type == "mmjy"
                    ? _c("div", [_vm._v("买卖物业交验")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.DQ_list[0].type == "zulin_new"
                    ? _c("div", [_vm._v("租赁合同")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.DQ_list[0].type == "zlls"
                    ? _c("div", [_vm._v("租赁两书")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.DQ_list[0].type == "zljy"
                    ? _c("div", [_vm._v("租赁物业交验")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.DQ_list[0].type == "shangye"
                    ? _c("div", [_vm._v("商业租赁合同")])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line" }, [
                _c("div", { staticClass: "line-pram" }, [_vm._v("合同编号")]),
                _vm._v(" "),
                _c("div", { staticClass: "line-text" }, [
                  _vm._v(_vm._s(_vm.DQ_list[0].htbh)),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm.isShow
      ? _c("div", { staticClass: "bottom" }, [
          _c(
            "div",
            {
              staticClass: "btn-exit",
              on: {
                click: function ($event) {
                  return _vm.loginout()
                },
              },
            },
            [_vm._v("退出登录")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("../images/icon/5.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("../images/icon/6.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("../images/icon/7.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-block" }, [
      _c("div", [
        _c("img", { attrs: { src: require("../images/icon/8.png"), alt: "" } }),
      ]),
      _vm._v(" "),
      _c("div", [_vm._v("我的顾问")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hd-icon" }, [
      _c("img", {
        staticClass: "hd-icon-img",
        attrs: { src: require("../images/icon/13.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "otherservice" }, [
      _c("div", { staticClass: "house-title" }, [_vm._v("其他服务")]),
      _vm._v(" "),
      _c("div", { staticClass: "service-list" }, [
        _c("div", [
          _c("div", [
            _c("img", {
              staticClass: "icon-img",
              attrs: { src: require("../images/icon/9.png"), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-text" }, [_vm._v("我的问答")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c("img", {
              staticClass: "icon-img",
              attrs: { src: require("../images/icon/10.png"), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-text" }, [_vm._v("我的点评")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c("img", {
              staticClass: "icon-img",
              attrs: { src: require("../images/icon/11.png"), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-text" }, [_vm._v("官方客服")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c("img", {
              staticClass: "icon-img",
              attrs: { src: require("../images/icon/12.png"), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-text" }, [_vm._v("用户反馈")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }